import ModulWithRedux from './ModulWithRedux';
import SpacerModuleData from './spacer/ModuleData';
import EditView from './spacer/EditView';
import InPlaceEditView from './spacer/InPlaceEditView';
import WebView from './spacer/WebView';

export default class ModulSpacer extends ModulWithRedux<SpacerModuleData> {

    static MAX_HEIGHT = 400;
    static MIN_HEIGHT = 10;

    helpArticleId = "spacer";

    getActionBarTabs() {
        return [
            {label: this.textLabel, content: this.getConnectedComponent(EditView)}
        ];
    }

    getInPlaceEditViewClass() {
        return InPlaceEditView;
    }

    getWebViewClass() {
        return WebView;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulSpacer.ts
 **/